import z from "zod"

export const GetLoopReturnsReturnInfoSchema = z.object({
  orderId: z.string(),
  email: z.string().optional(),
})

export const UpsertLoopReturnsIntegrationSchema = z.object({
  apiKey: z.string(),
})
